import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind } from 'Mri.Web.Common';
import * as React from 'react';
import { BsBoxArrowUpRight } from '@react-icons/all-files/bs/BsBoxArrowUpRight';
import { ButtonGroup, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from 'reactstrap';

export interface IZendeskLinkDropdownProps {
    readonly serialNumber?: string;
    readonly className?: string;
    readonly size?: 'md' | 'sm';
}

@autoinject
@observer
export class ZendeskLinkDropdown extends React.Component<IZendeskLinkDropdownProps> {
    public render() {
        return (
            <ButtonGroup size={this.props.size ?? 'md'} className={`${this.props.className}`}>
                <a
                    className={this.buttonClassName}
                    href="https://support.mri-inc.net/agent/search/1?q=type:ticket"
                    target="_blank"
                >
                    Zendesk
                </a>
                <UncontrolledButtonDropdown>
                    <DropdownToggle caret color="primary" size={this.props.size} />

                    <DropdownMenu>
                        <DropdownItem tag="a" href={this.openedUrl} className="fw-bold d-flex" target="_blank">
                            Opened <BsBoxArrowUpRight style={{ fontSize: 21 }} className="ms-auto py-1" />
                        </DropdownItem>

                        <DropdownItem tag="a" href={this.closedUrl} className="fw-bold d-flex" target="_blank">
                            Closed <BsBoxArrowUpRight style={{ fontSize: 21 }} className="ms-auto py-1" />
                        </DropdownItem>

                        <DropdownItem tag="a" href={this.openedRMAUrl} className="fw-bold d-flex" target="_blank">
                            Part RMA Opened &nbsp;
                            <BsBoxArrowUpRight style={{ fontSize: 21 }} className="ms-auto py-1" />
                        </DropdownItem>

                        <DropdownItem tag="a" href={this.closedRMAUrl} className="fw-bold d-flex" target="_blank">
                            Part RMA Closed &nbsp;
                            <BsBoxArrowUpRight style={{ fontSize: 21 }} className="ms-auto py-1" />
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledButtonDropdown>
            </ButtonGroup>
        );
    }

    @computed
    private get openedUrl() {
        const serialField = this.props.serialNumber ? `%20fieldvalue:${this.props.serialNumber}` : '';
        const openedUrl =
            'https://mri.zendesk.com/agent/search/1?q=type:ticket%20status:new%20status:open%20status:hold%20status:pending%20form:%22Support%20Ticket%22%20form:%22Support%20Ticket%20Anheuser%20Busch%22%20form:%22Monitoring%20Ticket%22%20order_by:updated_at%20sort:desc' +
            serialField;

        return openedUrl;
    }

    @computed
    private get closedUrl() {
        const serialField = this.props.serialNumber ? `%20fieldvalue:${this.props.serialNumber}` : '';
        const closedUrl =
            'https://mri.zendesk.com/agent/search/1?q=type:ticket%20status:closed%20status:solved%20form:%22Support%20Ticket%22%20form:%22Support%20Ticket%20Anheuser%20Busch%22%20form:%22Monitoring%20Ticket%22%20order_by:updated_at%20sort:desc' +
            serialField;

        return closedUrl;
    }

    @computed
    private get openedRMAUrl() {
        const serialField = this.props.serialNumber ? `%20fieldvalue:${this.props.serialNumber}` : '';
        const openedRMAUrl =
            'https://mri.zendesk.com/agent/search/1?q=type:ticket%20status:new%20status:open%20status:hold%20status:pending%20form:%22Part/RMA%22%20order_by:updated_at%20sort:desc' +
            serialField;

        return openedRMAUrl;
    }

    @computed
    private get closedRMAUrl() {
        const serialField = this.props.serialNumber ? `%20fieldvalue:${this.props.serialNumber}` : '';
        const closedRMAUrl =
            'https://mri.zendesk.com/agent/search/1?q=type:ticket%20status:closed%20status:solved%20%20form:%22Part/RMA%22%20order_by:updated_at%20sort:desc' +
            serialField;

        return closedRMAUrl;
    }

    @computed
    private get buttonClassName() {
        return `btn btn-primary btn-${this.props.size}`;
    }
}
